import { useEffect } from 'react';
import useSharedApps from '../sitecoreContext/useSharedApps';
import { BUILD_AND_PRICE_URL } from '../constants';
// TODO: refactor syncing URL with Redux state using middleware
const useSyncURLParamsFromState = (entries, defaultUpdateCondition = (a) => !!a) => {
    const baseUrl = useSharedApps(BUILD_AND_PRICE_URL);
    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        // eslint-disable-next-line no-restricted-syntax
        for (const { queryParam: searchParam, state, updateCondition = defaultUpdateCondition } of entries) {
            if (updateCondition(state)) {
                queryParams.set(searchParam, state);
            }
            else {
                queryParams.delete(searchParam);
            }
        }
        const { hash: currentHash, pathname } = window.location;
        if (pathname === baseUrl)
            return;
        const updatedParams = `${pathname}?${decodeURIComponent(queryParams.toString())}${currentHash}`;
        window.history.replaceState({}, '', updatedParams);
    }, [entries]);
};
export default useSyncURLParamsFromState;
